const CampaignConstants = {
    status: {
        ALL: 'all',
        CLIENT_DRAFT: 'client_draft',
        TO_DO: 'to_do',
        CLIENT_INPROGRESS: 'client_inprogress',
        CLIENT_COMPLETED: 'client_completed',
        CLIENT_CLOSED: 'client_closed',
    },
    service: {
        ALL: 'all',
        FREE: 'free',
        PAID: 'paid',
    },
    device: {
        ALL: 'all',
        IOS: 'ios',
        ANDROID: 'android',
        MAC: 'mac',
        WINDOWS: 'windows',
        OTHER: 'other',
    },
    area: {
        ALL: 'all',
        HANOI: '26',
        DANANG: '17',
        HCM: '60',
        OTHER: 'other',
    },
    questionAnswerType: {
        NORMAL_ANSWER: '1',
        OTHER_ANSWER: '2',
        NO_ANSWER: '3',
    },
};

export default CampaignConstants;
